import { render, staticRenderFns } from "./Customer-barcode.vue?vue&type=template&id=1d54a985"
import script from "./Customer-barcode.vue?vue&type=script&lang=js"
export * from "./Customer-barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports